import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import {
  downloadCSV,
  List,
  TextInput,
  useListContext,
  usePermissions,
} from "react-admin";
import FilterAmountApplied from "../unit/FilterAmountApplied";
import FilterAmountOffered from "../unit/FilterAmountOffered";
import FilterBank from "../unit/FilterBank";
import FilterBorrowerAgreement from "../unit/FilterBorrowerAgreement";
import FilterDecision from "../unit/FilterDecision";
import FilterProduct from "../unit/FilterProduct";
import FilterVerificationStatus from "../unit/FilterVerificationStatus";
import HmPageHeaderTitle from "../unit/HmPageHeaderTitle";
import PostPagination from "../unit/PostPagination";
import { ShowListTotal } from "../unit/ShowListTotal";
import formatDate from "../unit/formatDate";
import useNotify from "../unit/useNotify";
import { AdverseReasonFun } from "./AdverseReasonFun";
import { ApplciationFeeFun } from "./ApplciationFeeFun";
import ApplicationAside from "./ApplicationAside";
import { ApplicationDecisionFun } from "./ApplicationDecisionFun";
import { BorrowerAgreementFun } from "./BorrowerAgreementFun";
import { ExpiredDaysPassed } from "./ExpiredDaysPassed";
import ApplicationListActions from "./lists/ApplicationListActions";
import DefaultApplicationList from "./lists/DefaultApplicationList";
import HmLoading from "../unit/HmLoading";
import {
  getCachedMenuStats,
  isMenuStatsCacheExpired,
  preloadMenuStats,
} from "../layout/PreloadMenuStats";
import FilterBorrowerAcceptance from "../unit/FilterBorrowerAcceptance";
import FilterRecommendation from "../unit/FilterRecommendation";
import FilterApplicationFee from "../unit/FilterApplicationFee";
import CustomLoading from "../unit/CustomLoading";
import getFiltersFromURL from "../unit/getFiltersFromURL";
import { Suspense } from "react";
import NoResults from "../unit/NoResults";
import DisableHandleKeyDown from "../unit/DisableHandleKeyDown";
import CustomFilterText from "../unit/CustomFilterText";
import NoPermission from "../unit/NoPermission";
import FilterDisbursementStatus from "../unit/FilterDisbursementStatus";
const ApplicationFilterList = ({ ...props }) => {
  const listContext = useListContext();
  const { filterValues } = listContext;
  let filterStatus = filterValues?.status;
  if (filterStatus == "" || filterStatus == undefined) {
    filterStatus = "New";
  }
  const { total, data, isPending, isLoading, isFetching } = useListContext();
  if (isPending) return null;
  if (isFetching)
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid">
        loading ...
      </Typography>
    );
  if (!total || total === 0) {
    return (
      <Typography sx={{ p: 5 }} className="hm-list-datagrid no-results">
        <NoResults />
      </Typography>
    );
  }
  const handleCallBackRefreshMenu = () => {
    if (typeof props?.handleCallBackRefreshMenu === "function") {
      props.handleCallBackRefreshMenu();
    }
  };
  return (
    <>
      <DefaultApplicationList
        filterStatus={filterValues.status}
        filterSubStatus={filterValues.subStatus}
        handleCallBackRefreshMenu={handleCallBackRefreshMenu}
      />
    </>
  );
};

const ApplicationListTitle = () => {
  const listContext = useListContext();
  const { filterValues } = listContext;
  let filterStatus = filterValues?.status;
  if (filterStatus == "" || filterStatus == undefined) {
    filterStatus = "New";
  }
  let showApplicationTitle = "Applications";
  if (filterStatus == "New") {
    showApplicationTitle = "New";
  } else if (filterStatus == "Hold") {
    showApplicationTitle = "Hold";
  } else if (filterStatus == "Initial Review") {
    showApplicationTitle = "Initial Review";
  } else if (filterStatus == "Final Review") {
    showApplicationTitle = "Final Review";
  } else if (filterStatus == "To Notify") {
    showApplicationTitle = "Notification";
  } else if (filterStatus == "Countered") {
    showApplicationTitle = "Countered";
  } else if (filterStatus == "Approved") {
    showApplicationTitle = "Approved";
  } else if (filterStatus == "Declined") {
    showApplicationTitle = "Declined (Last 90 Days)";
  } else if (filterStatus == "Pre-Approved") {
    showApplicationTitle = "Pre-Approved";
  } else if (filterStatus == "Expired") {
    showApplicationTitle = "Expired (Last 90 Days)";
  } else if (filterStatus == "Incomplete") {
    showApplicationTitle = "Incompleted (Last 30 Days)";
  }
  return (
    <HmPageHeaderTitle
      title={showApplicationTitle}
      totalNumber={<ShowListTotal onlyShowNumber={true} />}
    />
  );
};

const ListWithLoading = ({ children, ...props }) => {
  const { isLoading, data } = useListContext();

  if (isLoading && !data) {
    return (
      <div
        style={{
          minHeight: 200,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          padding: 40,
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            border: "3px solid #f3f3f3",
            borderTop: "3px solid #1976d2",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            marginBottom: 16,
          }}
        ></div>
        <div>***Loading data, please wait ...</div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  return children;
};

const customApplicationNewExporter = (records: any) => {
  let filterStatus = "";
  if (records.length > 0) {
    filterStatus = records[0].sStatus;
  }
  let data = [];
  let title = {};

  if (filterStatus == "New") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountSubmit,
        feesType,
        feesStatus,
        feesChargeId,
        feesPaid,
        referral,
        referralVerify,
        sBank,
        employment_id,
        counselor_id,
        iCounselorVerification,
        counselor_verify_status,
        sSubType,
        iEmployerVerification,
        sEmployCompletedInternalSurvey,
        EmployedAtCompany,
        sCompany,
      } = record;
      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountSubmit,
        applicationfee: ApplciationFeeFun(
          feesType,
          feesStatus,
          feesChargeId,
          feesPaid
        ),
        referral,
        referralVerify,
        sBank,
      };
    });
    title = {
      dtDocusignComplete: "Application Submitted",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountSubmit: "Amount Applied",
      applicationfee: "Application Fee",
      referral: "Referral",
      referralVerify: "Verification",
      sBank: "Institution",
    };
  } else if (filterStatus == "Initial Review") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        amountSubmit,
        dtReview,
        recommendationOption,
        referral,
        referralVerify,
        sBank,
      } = record;
      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountSubmit,
        dtReview: formatDate(dtReview),
        referral,
        referralVerify,
        sBank,
      };
    });
    title = {
      dtDocusignComplete: "Application Submitted",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountSubmit: "Amount Applied",
      dtReview: "Last Reviewed",
      referral: "Referral",
      referralVerify: "Verification",
      sBank: "Institution",
    };
  } else if (filterStatus == "Final Review") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtReview,
        recommendationOption,
        referral,
        sBank,
      } = record;
      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtReview: formatDate(dtReview),
        recommendationOption,
        referral,
        sBank,
      };
    });
    title = {
      dtDocusignComplete: "Application Submitted",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountReview: "Amount Offered",
      dtReview: "Last Reviewed",
      recommendationOption: "Recommend",
      referral: "Referral",
      sBank: "Institution",
    };
  } else if (filterStatus == "To Notify") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtReview,
        reviewOption,
        recommendationOption,
        referral,
        sBank,
      } = record;
      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtReview: formatDate(dtReview),
        decision: ApplicationDecisionFun(reviewOption, recommendationOption),
        referral,
        sBank,
      };
    });
    title = {
      dtDocusignComplete: "Application Submitted",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountReview: "Amount Offered",
      dtReview: "Last Reviewed",
      decision: "Decision",
      referral: "Referral",
      sBank: "Institution",
    };
  } else if (filterStatus == "Countered" || filterStatus == "Pre-Approved") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtNotify,
        sApplicationResponse,
        reviewOption,
        recommendationOption,
        referral,
        sBank,
      } = record;
      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtNotify: formatDate(dtNotify),
        sApplicationResponse,
        referral,
        sBank,
      };
    });
    title = {
      dtDocusignComplete: "Application Submitted",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountReview: "Amount Offered",
      dtNotify: "Date Notified",
      sApplicationResponse: "Borrower Acceptance",
      referral: "Referral",
      sBank: "Institution",
    };
  } else if (filterStatus == "Approved") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtNotify,
        borrowerAgreement,
        referral,
        sBank,
      } = record;
      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtNotify: formatDate(dtNotify),
        borrowerAgreement: BorrowerAgreementFun(borrowerAgreement),
        referral,
        sBank,
      };
    });
    title = {
      dtDocusignComplete: "Application Submitted",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountReview: "Amount Offered",
      dtNotify: "Date Notified",
      borrowerAgreement: "Borrower Agreeement",
      referral: "Referral",
      sBank: "Institution",
    };
  } else if (filterStatus == "Hold") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountSubmit,
        dtReview,
        reviewBy,
        referral,
        sBank,
      } = record;
      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountSubmit,
        dtReview: formatDate(dtReview),
        reviewBy,
        referral,
        sBank,
      };
    });
    title = {
      dtDocusignComplete: "Application Submitted",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountSubmit: "Amount Applied",
      dtReview: "Last Reviewed",
      reviewBy: "Reviewed By",
      referral: "Referral",
      sBank: "Institution",
    };
  } else if (filterStatus == "Expired") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtNotify,
        referral,
        sBank,
      } = record;

      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtNotify,
        daysPassed: ExpiredDaysPassed(dtNotify),
        referral,
        sBank,
      };
    });
    title = {
      dtDocusignComplete: "Application Submitted",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountReview: "Amount Offered",
      dtNotify: "Date Notified",
      daysPassed: "Days Passed",
      referral: "Referral",
      sBank: "Institution",
    };
  } else if (filterStatus == "Declined") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtNotify,
        adverseReason,
        referral,
        sBank,
      } = record;
      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountReview,
        dtNotify: formatDate(dtNotify),
        adverseReason: AdverseReasonFun(adverseReason),
        referral,
        sBank,
      };
    });
    title = {
      dtDocusignComplete: "Application Submitted",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountReview: "Amount Offered",
      dtNotify: "Date Notified",
      adverseReason: "Adverse Reason",
      referral: "Referral",
      sBank: "Institution",
    };
  } else if (filterStatus == "Incomplete") {
    data = records.map((record: any) => {
      const {
        id,
        sLoanNum,
        iUserId,
        dtInsert,
        dtDocusignComplete,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountSubmit,
        dtReview,
        last_login_time,
        referral,
        sBank,
      } = record;
      return {
        dtDocusignComplete: formatDate(dtDocusignComplete),
        id,
        sLoanNum,
        iUserId,
        sProductName,
        fullname,
        coapplication_name,
        guarantor_name,
        amountSubmit,
        last_login_time,
        referral,
        sBank,
      };
    });
    title = {
      dtInsert: "Application Started",
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      sProductName: "Product",
      fullname: "Applicant",
      coapplication_name: "Co-Applicant",
      guarantor_name: "Guarantor",
      amountSubmit: "Amount Applied",
      last_login_time: "Last Login",
      referral: "Referral",
      sBank: "Institution",
    };
  } else {
    data = records.map((record: any) => {
      const { id, sLoanNum, iUserId, dtInsert, dtDocusignComplete } = record;
      return {
        id,
        sLoanNum,
        iUserId,
        dtInsert: formatDate(dtInsert),
        dtDocusignComplete: formatDate(dtDocusignComplete),
      };
    });
    title = {
      id: "App #",
      sLoanNum: "Loan #",
      iUserId: "User #",
      dtInsert: "Application Started",
      dtDocusignComplete: "Application Submitted",
    };
  }

  return {
    title: title,
    data: data,
    filterStatus: filterStatus,
  };
};
const customApplicationExporter = (records: any) => {
  const filterData = customApplicationNewExporter(records);
  let csvTitle = filterData.title;
  let data = filterData.data;
  let filterStatus = filterData.filterStatus;

  //{{{
  const currentFilters = getFiltersFromURL();
  const filter_status = currentFilters?.status;
  const filter_curStatus = currentFilters?.subStatus;
  const filter_filterRemainingterm = currentFilters?.filterRemainingterm;
  const otherFilters = { ...currentFilters };
  delete otherFilters.status;
  delete otherFilters.curStatus;
  delete otherFilters.subStatus;
  delete otherFilters.filterRemainingterm;
  const filterString = Object.entries(otherFilters)
    .map(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        return `[${getFieldTitle(key)} ${getFieldValueType(
          key
        )} "${getFieldValue(key, value)}"]`;
      }
      return "";
    })
    .filter(Boolean)
    .join("");

  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));
  let filename = "Applications";
  filename += customApplicationFilterText(filter_status, filter_curStatus);
  if (filterString) {
    csvDataStr.push("");
    csvDataStr.push("Filters Applied:" + filterString);
  }

  downloadCSV(csvDataStr.join("\n"), filename);
};

function getFieldTitle(field: string) {
  const titleMap = {
    id: "App #",
    iUserId: "User #",
    sLoanNum: "Loan #",
    product: "Product",
    userName: "Applicant Name",
    userEmail: "Applicant Email",
    coName: "Co-Applicant Name",
    guarantorName: "Guarantor Name",
    amountSubmit: "Amount Applied",
    amountReview: "Amount Offered",
    decision: "Decision",
    counselor: "Referring Counselor",
    employer: "Referring Employer",
    referralVerify: "Verification Status",
    appFees: "Application Fees Status",
    borrowerAgreement: "Borrower Agreement",
    sApplicationResponse: "Borrower Acceptance",
  };
  return titleMap[field] || field;
}
function getFieldValueType(field: string) {
  const titleMap = {
    id: "contains",
    iUserId: "contains",
    sLoanNum: "contains",
    product: "is",
    userName: "contains",
    userEmail: "contains",
    coName: "contains",
    guarantorName: "contains",
    amountSubmit: "in",
    amountReview: "in",
    decision: "is",
    counselor: "contains",
    employer: "contains",
    referralVerify: "is",
    appFees: "is",
    borrowerAgreement: "is",
    sApplicationResponse: "is",
  };
  return titleMap[field] || field;
}

function getFieldValue(field: string, value: any) {
  if (
    field == "amountOffer" ||
    field == "amountReview" ||
    field == "amountSubmit"
  ) {
    if (value == "1") {
      return "<$1000";
    } else if (value == "2") {
      return "$1000-$5000";
    } else if (value == "3") {
      return "$5000-$10,000";
    } else if (value == "4") {
      return "$10,000-$20,000";
    } else if (value == "5") {
      return ">$20,000";
    }
  } else {
    return value;
  }
}
function customApplicationFilterText(
  filter_status: string,
  filter_curStatus: string
) {
  let filterText = "_";

  // {"status":"New","subStatus":"Verification Pending"}
  if (filter_status == "New" && filter_curStatus == "Verification Pending") {
    filterText += "Under Review_Verification Pending";
    // {"status":"New","subStatus":"Ready for Review"}
  } else if (filter_status == "New" && filter_curStatus == "Ready for Review") {
    filterText += "Under Review_Ready for Screening";
    // {"status":"Initial Review"}
  } else if (filter_status == "Initial Review") {
    filterText += "Under Review_Ready for Initial Review";
    // {"status":"Final Review"}
  } else if (filter_status == "Final Review") {
    filterText += "Under Review_Ready for Final Review";
    // {"status":"To Notify"}
  } else if (filter_status == "To Notify") {
    filterText += "Under Review_Ready for Notification";
    // {"status":"CounteredAndPreApproved","subStatus":"Offer Accepted"}
  } else if (
    filter_status == "CounteredAndPreApproved" &&
    filter_curStatus == "Offer Accepted"
  ) {
    filterText += "Countered and Pre-Approved_Offer Accepted";
    // {"status":"CounteredAndPreApproved","subStatus":"Acceptance Pending"}
  } else if (
    filter_status == "CounteredAndPreApproved" &&
    filter_curStatus == "Acceptance Pending"
  ) {
    filterText += "Countered and Pre-Approved_Acceptance Pending";
    // {"status":"Approved","subStatus":"Signature Completed"}
  } else if (
    filter_status == "Approved" &&
    filter_curStatus == "Signature Completed"
  ) {
    filterText += "Approved_Ready for Disbursement";
    // {"status":"Approved","subStatus":"Pending Signature"}
  } else if (
    filter_status == "Approved" &&
    filter_curStatus == "Pending Signature"
  ) {
    filterText += "Approved_Pending Closing";
  } else if (
    // {"status":"Hold"}
    filter_status == "Hold"
  ) {
    filterText += "Other_Hold";
    // {"status":"Expired"}
  } else if (filter_status == "Expired") {
    filterText += "Other_Expired (Last 90 Days)";
    // {"status":"Declined"}
  } else if (filter_status == "Declined") {
    filterText += "Other_Declined (Last 90 Days)";
    // {"status":"Incomplete"}
  } else if (filter_status == "Incomplete") {
    filterText += "Other_Incompleted (Last 30 Days)";
  } else if (filter_status) {
    filterText += filter_status;
  }
  return filterText;
}

const ApplicationList = () => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [record, setRecord] = useState<{ total: number } | null>(null);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (isMenuStatsCacheExpired("application", 3600000)) {
          await preloadMenuStats("application");
        }
        const data = getCachedMenuStats("application");
        setTotal(data ? data.data : 0);
      } catch (error) {
        console.error("Failed to load application stats:", error);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const handleCallBackRefreshMenu = () => {
    localStorage.removeItem("applicationMenuStats");
    const fetchData = async () => {
      try {
        if (isMenuStatsCacheExpired("application", 3600000)) {
          await preloadMenuStats("application");
        }
        const data = getCachedMenuStats("application");
        setTotal(data ? data.data : 0);
      } catch (error) {
        setTotal(0);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  };
  const [applicationFilterData, setApplicationFilterData] = useState([
    <TextInput
      label="App #"
      source="id"
      defaultValue=""
      variant="outlined"
      onKeyDown={DisableHandleKeyDown}
    />,
    <CustomFilterText
      label="User #"
      source="iUserId"
      defaultValue=""
      variant="outlined"
    />,
    <CustomFilterText
      label="Loan #"
      source="sLoanNum"
      defaultValue=""
      variant="outlined"
    />,
    <FilterProduct label="Product" source="product" before="and" />,
    <CustomFilterText
      label="Applicant Name"
      source="userName"
      defaultValue=""
      variant="outlined"
    />,
    <CustomFilterText
      label="Applicant Email"
      source="userEmail"
      defaultValue=""
      variant="outlined"
    />,
    <CustomFilterText
      label="Co-Applicant Name"
      source="coName"
      defaultValue=""
      variant="outlined"
    />,
    <CustomFilterText
      label="Guarantor Name"
      source="guarantorName"
      defaultValue=""
      variant="outlined"
    />,

    <FilterAmountApplied
      label="Amount Applied"
      source="amountSubmit"
      before="and"
    />,
    <FilterAmountOffered
      label="Amount Offered"
      source="amountOffer"
      before="and"
      disabled={true}
    />,
    <FilterDecision
      label="Decision"
      source="sReview"
      before="and"
      disabled={true}
    />,
    <CustomFilterText
      label="Referring Counselor"
      source="counselor"
      defaultValue=""
      variant="outlined"
    />,
    <CustomFilterText
      label="Referring Employer"
      source="employer"
      defaultValue=""
      variant="outlined"
    />,
    <FilterVerificationStatus
      source="referralVerify"
      label="Verification Status"
      before="and"
    />,
    <FilterApplicationFee
      label="Application Fees Status"
      source="appFees"
      before="and"
    />,
    <FilterDisbursementStatus
      label="Disbursement Status"
      source="disbursementStatus"
      before="and"
      disabled={true}
    />,
    <FilterBorrowerAgreement
      label="Borrower Agreement"
      source="sBorrowerAgreement"
      before="and"
      disabled={true}
    />,

    <FilterBorrowerAcceptance
      label="Borrower Acceptance"
      source="sApplicationResponse"
      before="and"
      disabled={true}
    />,
  ]);

  const handleFilterStatusChange = (newStatus: string, subStatus: string) => {
    const ApplicationListFilters = [
      <TextInput
        label="App #"
        source="id"
        defaultValue=""
        variant="outlined"
        onKeyDown={DisableHandleKeyDown}
      />,
      <CustomFilterText label="User #" source="iUserId" defaultValue="" />,
      <CustomFilterText label="Loan #" source="sLoanNum" defaultValue="" />,
      <FilterProduct label="Product" source="product" before="and" />,
      <CustomFilterText
        label="Applicant Name"
        source="userName"
        defaultValue=""
      />,
      <CustomFilterText
        label="Applicant Email"
        source="userEmail"
        defaultValue=""
      />,
      <CustomFilterText
        label="Co-Applicant Name"
        source="coName"
        defaultValue=""
      />,
      <CustomFilterText
        label="Guarantor Name"
        source="guarantorName"
        defaultValue=""
      />,
      <FilterAmountApplied
        label="Amount Applied"
        source="amountSubmit"
        before="and"
      />,
      <FilterAmountOffered
        label="Amount Offered"
        source="amountOffer"
        before="and"
        disabled={
          newStatus == "New" ||
          newStatus == "Initial Review" ||
          newStatus == "Declined" ||
          newStatus == "Hold" ||
          newStatus == "Incomplete"
            ? true
            : false
        }
      />,
      <FilterDecision
        label={"Decision"}
        source="sReview"
        before="and"
        disabled={
          newStatus != "To Notify" &&
          newStatus != "Expired" &&
          newStatus != "Final Review" &&
          newStatus != "CounteredAndPreApproved"
        }
      />,
      <CustomFilterText
        label="Referring Counselor"
        source="counselor"
        defaultValue=""
      />,
      <CustomFilterText
        label="Referring Employer"
        source="employer"
        defaultValue=""
      />,
      <FilterVerificationStatus
        source="referralVerify"
        label="Verification Status"
        before="and"
        disabled={newStatus == "Incomplete" ? true : false}
      />,
      <FilterApplicationFee
        label="Application Fees Status"
        source="appFees"
        before="and"
        // disabled={true} //only show it in New
        disabled={newStatus == "New" ? false : true}
      />,
      <FilterDisbursementStatus
        label="Disbursement Status"
        source="disbursementStatus"
        before="and"
        disabled={
          newStatus !== "Approved" && subStatus !== "Signature Completed"
            ? true
            : false
        }
      />,
      <FilterBorrowerAgreement
        label={"Borrower Agreement"}
        source="sBorrowerAgreement"
        before="and"
        disabled={newStatus != "Approved" ? true : false}
        // disabled={true}
      />,
      <FilterBorrowerAcceptance
        label="Borrower Acceptance"
        source="sApplicationResponse"
        before="and"
        disabled={
          newStatus != "Countered" &&
          newStatus != "Pre-Approved" &&
          newStatus != "CounteredAndPreApproved"
            ? true
            : false
        }
      />,
    ];

    const authrole = localStorage.getItem("authrole");
    if (authrole == "admin") {
      ApplicationListFilters.push(
        <FilterBank label="Institution" source="sBank" before="and" />
      );
    }
    setApplicationFilterData(ApplicationListFilters);
  };

  if (!permissions.includes("personal_applications")) {
    return <NoPermission />;
  }

  return (
    <>
      <List
        actions={<ApplicationListActions />}
        filters={applicationFilterData}
        // disableSyncWithLocation
        sort={{ field: "id", order: "DESC" }}
        aside={
          <ApplicationAside
            totalData={total}
            onChange={handleFilterStatusChange}
          />
        }
        exporter={customApplicationExporter}
        pagination={<PostPagination />}
        perPage={25}
        sx={{
          width: "100%",
          borderRadius: "0px",
          "& .MuiCard-root": {
            borderRadius: "0px",
          },
          "& .RaList-actions form": {
            flex: "0 1 350%",
          },
          "& .RaList-actions form .filter-field .MuiInputBase-input": {
            width: "230px",
          },
          "& .RaList-actions .RaFilterForm-filterFormInput:first-child .MuiInputBase-root::before":
            {
              display: "none",
            },
          "& .RaList-actions .filter-field:first-child .MuiFormControl-root": {
            marginLeft: 0,
          },
        }}
        empty={
          <Typography className="no-results">
            <NoResults />
          </Typography>
        }
        emptyWhileLoading={false}
        loading={<HmLoading />}
      >
        <ApplicationFilterList
          handleCallBackRefreshMenu={handleCallBackRefreshMenu}
        />
      </List>
    </>
  );
};

export default ApplicationList;
